<owl-carousel-o
  [options]="HomeSliderConfig"
  class="home-slider"
  [ngClass]="class"
>
  <ng-container *ngFor="let slider of sliders">
    <ng-template carouselSlide>
      <div
        class="home"
        [ngClass]="textClass"
        [ngStyle]="{ 'background-image': 'url(' + slider.imageUrl + ')' }"
      >
        <div class="container">
          <div class="row">
            <div class="col position-relative">
              <h1 class="animated">sale</h1>

              <div class="slider-contain">
                <div>
                  <h4 class="text-white" style="text-shadow: 4px 1px 2px black">
                    {{ slider.label }}
                  </h4>
                  <h1 class="text-white" style="text-shadow: 5px 1px 4px black">
                    {{ slider.subLabel }}
                  </h1>
                  <a
                    *ngIf="slider?.productId"
                    [routerLink]="['/shop/product/', slider?.productId]"
                    class="btn btn-solid"
                    [ngClass]="buttonClass"
                  >
                    Inquiry Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
</owl-carousel-o>
